"use strict"

class SRecoverPasswordPage {
    init() {
        this.view = new Vue({
            el: "#contentwrap",
            name: "recover-password",
            data() {
                return {
                    brand: window.brand,
                }
            },
            method: {
                validEmail() {
                    return validate_element($("#register_emai"))
                }
            },
            components: {
                shopNav: ShopNav,
            }
        });
    }
}
